import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-icon-button',
  templateUrl: './card-icon-button.component.html',
  styleUrls: ['./card-icon-button.component.scss']
})
export class CardIconButtonComponent implements OnInit {
  @Input('title') title : string;
  @Input('iconPath') iconPath : string;

  constructor() { }

  ngOnInit() {
  }

}
